import {
  ConnectionType,
  IntegrationKind,
} from "@redotech/redo-integrations-core";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const ConnectionDisplayMetadataSchema_ = z.object({
  inputLabels: z.record(z.string(), z.string()).optional(),
  helpText: z.string().optional(),
  helpUrl: z.string().optional(),
  helpUrlText: z.string().optional(),
});
export const ConnectionDisplayMetadataSchema: z.ZodType<ConnectionDisplayMetadata> =
  ConnectionDisplayMetadataSchema_;
export interface ConnectionDisplayMetadata
  extends z.infer<typeof ConnectionDisplayMetadataSchema_> {}

export const ConnectionSchema = z.object({
  identifier: z.string(),
  displayName: z.string(),
  connectionType: createEnum(ConnectionType),
  isActive: z.boolean(),
  displayMetadata: ConnectionDisplayMetadataSchema.optional(),
});

export const IntegrationSchema = z.object({
  identifier: createEnum(IntegrationKind),
  displayName: z.string(),
  displayDescription: z.string().optional(),
  connections: z.record(z.string(), ConnectionSchema),
});

export type Connection = z.infer<typeof ConnectionSchema>;
export type Integration = z.infer<typeof IntegrationSchema>;
